import { memo } from 'react';

import { type BoardAncestors, type Library } from '@air/api/types';

import { useGeneralLibraryTitle } from '~/components/LibraryBeta/hooks/useGeneralLibraryTitle';
import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type PrivateGalleryBoardAncestorsProps = {
  libraryTitle: Library['title'] | undefined;
  ancestors: BoardAncestors | undefined;
};

export const PrivateGalleryBoardAncestors = memo(({ libraryTitle, ancestors }: PrivateGalleryBoardAncestorsProps) => {
  const { libraries: librariesFlag } = usePrivateAddOnFeatures();

  const { currentWorkspace } = useCurrentWorkspace();
  const { generalLibraryTitle } = useGeneralLibraryTitle();

  if (!ancestors?.length) {
    if (librariesFlag) {
      return <>{libraryTitle ?? generalLibraryTitle}</>;
    } else {
      return <>{currentWorkspace?.name}</>;
    }
  }

  const nearestAncestorTitle = ancestors[ancestors.length - 1].title;

  return <>{ancestors.length > 1 ? `··· / ${nearestAncestorTitle}` : nearestAncestorTitle}</>;
});

PrivateGalleryBoardAncestors.displayName = 'PrivateGalleryBoardAncestors';
